
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/default",
      function () {
        return require("private-next-pages/search/default.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/default"])
      });
    }
  